import React from 'react';
import { Stack } from '@mui/material';
import Accordion, { AccordionItem } from '@ingka/accordion';
import EditFinancesBlock from './EditFinancesBlock';
import { ACCORDION_FINANCIAL_TOTALS } from './constants';

const EditFinancesTotal = ({ currency, currencyRate }) => {
  return (
    <Stack>
      <Accordion>
        {ACCORDION_FINANCIAL_TOTALS.map((item, index) => (
          <AccordionItem id={item.title} key={index} title={item.title}>
            <EditFinancesBlock
              currency={currency}
              currencyRate={currencyRate}
              label={item.label}
              name={item.name}
            />
          </AccordionItem>
        ))}
      </Accordion>
    </Stack>
  );
};
export default EditFinancesTotal;
